import React, { Fragment, useState } from 'react';
import * as styles from './LanguageSwitcher.css';
import {
  Box,
  Columns,
  Column,
  Text,
  IconChevron,
  Divider,
  IconLanguage,
  IconTick,
} from 'braid-design-system';
import { useAppConfig } from 'src/hooks/useAppConfig';
import { KeyMap, LanguageToTextMap } from 'src/types';
import { useRoutes, getWindowPathWithoutLanguage } from 'src/hooks/useRoutes';
import useMediaQuery from 'src/hooks/useMediaQuery';
import DocumentClickHandler from 'src/common/Handlers/DocumentClickHandler';
import DocumentKeyEventHandler from 'src/common/Handlers/DocumentKeyEventHandler';

const LanguageSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { LANGUAGE, SUPPORTED_LANGUAGES } = useAppConfig();
  const { routes } = useRoutes();
  const { isDesktop } = useMediaQuery();

  if (SUPPORTED_LANGUAGES.length <= 1 || !isDesktop) {
    return null;
  }

  const toggleLangSwitcher = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Box position="relative">
      <button
        className={`${styles.container}`}
        onClick={toggleLangSwitcher}
        data-cy="language-selected"
      >
        <Box background="brand">
          <Columns alignY="center" space="xsmall">
            <Column>
              <IconLanguage data={{ testid: 'icon-language' }} size="small" />
            </Column>
            <Column>
              <Text weight="strong">{LANGUAGE?.toUpperCase()}</Text>
            </Column>
            <Column width="content">
              <IconChevron direction={isOpen ? 'up' : 'down'} />
            </Column>
          </Columns>
        </Box>
      </button>
      {isOpen && (
        <DocumentClickHandler onOutsideElementClick={toggleLangSwitcher}>
          <DocumentKeyEventHandler
            keyMap={{
              [KeyMap.Escape]: toggleLangSwitcher,
            }}
          >
            <Box background="surface" className={styles.langSwitcherMenu}>
              {SUPPORTED_LANGUAGES.map((language) => (
                <Fragment key={language}>
                  <Box
                    role="language"
                    background="body"
                    padding="small"
                    display="flex"
                    className={styles.mousePointer}
                    onClick={() =>
                      window.location.assign(
                        routes.urlResolver({
                          language,
                          path: getWindowPathWithoutLanguage(),
                        }),
                      )
                    }
                  >
                    <Box display="flex" alignItems="center">
                      <Box marginRight="xsmall">
                        {LANGUAGE === language ? (
                          <IconTick tone="positive" />
                        ) : (
                          <Box padding="small" />
                        )}
                      </Box>
                      <Box display="flex">
                        <Text
                          weight={LANGUAGE === language ? 'strong' : 'regular'}
                        >
                          {LanguageToTextMap[language]}
                        </Text>
                      </Box>
                    </Box>
                  </Box>
                  <Divider />
                </Fragment>
              ))}
            </Box>
          </DocumentKeyEventHandler>
        </DocumentClickHandler>
      )}
    </Box>
  );
};

export default LanguageSwitcher;
